<template>
  <div class="dashboard-block" >
    <h2>Messaging</h2>
    <ul class="item-detail item-detail-simple">
      <booking-thread-list-item
        v-for="thread in threads"
        :key="thread.id"
        :thread="thread"
        :booking="booking"/>
    </ul>
  </div>
</template>

<script>
import BookingThreadListItem from './BookingThreadListItem'

export default {
  props: {
    threads: {
      required: true,
      type: Array
    },
    booking: {
      required: true,
      type: Object
    }
  },

  components: {
    BookingThreadListItem
  }
}
</script>
